/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.book-trip')
 */
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getResortBookTripServerSideProps } from 'page-components/resort/book-trip';
import { propsWithI18NSSR } from 'util/propsWithI18n';

export default Object.assign(Component, { Layout: ResortLayout });

export const getServerSideProps = propsWithI18NSSR(getResortBookTripServerSideProps);
